import { render, staticRenderFns } from "./authAdmin.vue?vue&type=template&id=6f86a6ff"
import script from "./authAdmin.vue?vue&type=script&lang=js"
export * from "./authAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports